import { useState, useEffect, useCallback } from "react";
import { styled } from "@mui/material/styles";
import { Box, TextField, Button } from "@mui/material";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { FileUploader } from "react-drag-drop-files";
import { useDialog } from "react-st-modal";
import Modal_Table from "../../../main_components/modal/modal_Table";
// import "../../expense.css";
import { refresh_token } from "../../../main_components/tokens/tokenrefresh";
import jsPDF from "jspdf";
import { expense_payment_account_get, expenses_concept_list_get, expenses_post } from "../../../services/expenses/expense";

const ValidationTextField = styled(TextField)({
  "& input:valid + fieldset": { borderColor: "green", borderWidth: 2 },
  "& input:valid:focus + fieldset": {
    borderLeftWidth: 6,
    padding: "4px !important",
  },
});

const CREATE_UPDATE_EXPENSE = ({
  codDescripcion = "",
  codImporte = "",
  codAccount = "",
  codDate = "",
  codCocept = "",
  foreing,
  origin,
  alertas,
  handleSubmit
}) => {
  const [descripcion, setDescripcion] = useState(codDescripcion);
  const [importe, setImporte] = useState(codImporte);
  const [concepto, setConcepto] = useState(codCocept);
  const [conceptoAccount, setconceptoAccount] = useState("");

  const [fecha, setFecha] = useState(codDate);
  const [cuentaSeleccionada, setCuentaSeleccionada] = useState(codAccount);
  const [conceptosList, setConceptosList] = useState([]);
  const [cuentasList, setCuentasList] = useState([]);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [modalT, setModalT] = useState(false);
  const dialog = useDialog();

  const fileTypes = ["PDF", "JPG", "JPEG", "PNG"];

  const fetchConceptos = useCallback(async () => {
    try {
      if (await refresh_token()) {
        const { data } = await expenses_concept_list_get(foreing);
        setConceptosList([{ id_account: "0", concept: "SELECCIONE UNA OPCIÓN" }, ...data]);
      }
    } catch (error) {
      setConceptosList([]);
    }
  }, [foreing]);

  const fetchCuentas = useCallback(async () => {
    try {
      if (await refresh_token()) {
        const { data } = await expense_payment_account_get();
        setCuentasList([{ id: "0", payment_method: "SELECCIONE UNA OPCIÓN" }, ...data]);
      }
    } catch (error) {
      setCuentasList([]);
    }
  }, []);

  useEffect(() => {
    fetchConceptos();
    fetchCuentas();
  }, [fetchConceptos, fetchCuentas]);

  const handleFileChange = async (file) => {
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (fileExtension === 'pdf') {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setFile(reader.result.replace("data:application/pdf;base64,", ""));
        setFileName(file.name);
      };
    } else {
      convertImageToPdf(URL.createObjectURL(file)).then((pdfBase64) => {
        setFile(pdfBase64);
        setFileName(file.name.replace(/\.[^/.]+$/, '') + ".pdf");
      });
    }
  };

  const convertImageToPdf = (imagePath) => {
    return new Promise((resolve) => {
      const pdf = new jsPDF();
      const img = new Image();
      img.onload = () => {
        pdf.addImage(img, "JPEG", 10, 10, 190, 277);
        resolve(pdf.output("datauristring").split(",")[1]);
      };
      img.src = imagePath;
    });
  };

  const handleSubmitExpense = async () => {
    try {
      if (await refresh_token()) {

        const data = {
          expense: {
            concept: concepto,
            id_payment: Number(cuentaSeleccionada),
            account: conceptoAccount,
            description: descripcion,
            date: fecha,
            amount: Number(importe),
            origin: origin,
          },
          file: { content: file, type: "pdf" },
        };



        setModalT(true);
        try {
          await expenses_post(data);
          setModalT(false);
          alertas?.("Gasto Registrado con éxito", true);
          dialog.close(true);
          handleSubmit?.();
        } catch (err) {
          setModalT(false);
          alertas?.("Error al registrar el gasto", false);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };


  return (
    <div style={{ width: "95%", margin: "0 auto" }}>
      <Modal_Table modalT={modalT} />
      <form>
        {/* Concepto */}
        <Box sx={{ display: "flex", width: "100%", margin: "auto", p: 1 }}>
          <TextField
            select
            label="Concepto"
            value={concepto}
            onChange={(e) => {
              const selectedConcepto = e.target.value;
              setConcepto(selectedConcepto);
              const selectedConceptoObj = conceptosList.find((option) => option.concept === selectedConcepto);
              if (selectedConceptoObj) {
                setconceptoAccount(selectedConceptoObj.account);
              }
            }}
            fullWidth
            size="small"
            SelectProps={{ native: true }}
          >
            {conceptosList.map((option, index) => (
              <option key={`${option.id_account}-${index}`} value={option.concept}>
                {option.concept}
              </option>
            ))}
          </TextField>
        </Box>


        {/* Descripción */}
        <Box sx={{ display: "flex", width: "100%", margin: "auto", p: 1 }}>
          <TextareaAutosize
            value={descripcion}
            placeholder="Descripción"
            style={{ width: "100%", padding: "10px", minHeight: "100px" }}
            onChange={(e) => setDescripcion(e.target.value)}
          />
        </Box>

        {/* Fecha e Importe */}
        <Box sx={{ display: "flex", gap: 1, width: "100%", margin: "auto", p: 1 }}>
          <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
          <ValidationTextField
            label="Importe"
            type="number"
            value={importe}
            onChange={(e) => setImporte(e.target.value)}
            fullWidth
          />
        </Box>

        {/* Cuenta */}
        <Box sx={{ display: "flex", width: "100%", margin: "auto", p: 1 }}>
          <TextField
            select
            label="Cuenta de pago"
            value={cuentaSeleccionada}
            onChange={(e) => setCuentaSeleccionada(e.target.value)}
            fullWidth
            size="small"
            SelectProps={{ native: true }}
          >
            {cuentasList.map((option, index) => (
              <option key={`${option.id}-${index}`} value={option.id}>
                {option.payment_method}
              </option>
            ))}
          </TextField>
        </Box>

        {/* Subir archivo */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "98%",
            height: "120px",
            margin: "auto",
            p: 1,
            textAlign: "center",
            border: "2px dashed #ccc",
            borderRadius: "8px",
            position: "relative",
          }}
        >
          <FileUploader handleChange={handleFileChange} name="file" types={fileTypes} />

          {/* Mostrar nombre del archivo si existe */}
          {fileName && (
            <p style={{
              marginTop: "10px",
              fontSize: "14px",
              fontWeight: "bold",
              color: "#333",
              textAlign: "center",
              wordBreak: "break-word", // 📌 Rompe palabras largas para evitar desbordes
            }}>
              {fileName}
            </p>
          )}
        </Box>

        {/* Botones */}
        <Box sx={{ display: "flex", gap: 1, width: "100%", margin: "auto", p: 1 }}>
          <Button variant="contained" fullWidth sx={{ background: "green" }} onClick={handleSubmitExpense}>Crear</Button>
          <Button variant="contained" fullWidth sx={{ background: "red" }} onClick={() => dialog.close()}>Cancelar</Button>
        </Box>
      </form>
    </div>
  );
};

export default CREATE_UPDATE_EXPENSE;
